import { render, staticRenderFns } from "./dailypackage.vue?vue&type=template&id=f9ae3b08&scoped=true"
import script from "./dailypackage.vue?vue&type=script&lang=ts"
export * from "./dailypackage.vue?vue&type=script&lang=ts"
import style0 from "./dailypackage.vue?vue&type=style&index=0&id=f9ae3b08&prod&lang=less&scoped=true"
import style1 from "./dailypackage.vue?vue&type=style&index=1&id=f9ae3b08&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ae3b08",
  null
  
)

export default component.exports